/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { Modal } from 'antd';
import { useIntl } from 'react-intl';
import { useThemeSwitcher } from 'react-css-theme-switcher';

import doReturnTheme from '~src/styles/themeEngine';
import icon from '~components/_common/icon/icon';
import { useProjectId } from '~src/hooks/useProjectId';
import { ContactSettingsTab } from '~components/popups-modals/DetailsLayouts/tabs/ContactSettingsTab';

const ResourceSetting = ({
  state,
  onCancel,
}: {
  state: boolean;
  onCancel: () => void;
}) => {
  const { currentTheme } = useThemeSwitcher();
  const theme = doReturnTheme(currentTheme);
  const intl = useIntl();
  const projectId = useProjectId();

  const handleCancel = () => {
    onCancel();
  };

  return (
    <Modal
      title={
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            fontSize: '18px',
            fontWeight: 'bold',
          }}>
          {icon('far', 'address-card', {
            color: theme.colors.secondary,
            fontSize: '20px',
          })}
          {intl.formatMessage({ id: 'project-contacts-settings' })}
        </div>
      }
      centered
      visible={state}
      onCancel={handleCancel}
      footer={null}
      closeIcon={icon(
        'far',
        'times',
        { color: theme.colors.darkGray, fontSize: '20px' },
        'close'
      )}
      width={1100}>
      <ContactSettingsTab active={state} projectIdOverride={projectId} />
    </Modal>
  );
};

export default ResourceSetting;

// OLD MODAL LOGIC
// NEW LOGIC IS MOVED TO TAB WITH UPGRADES
// /** @jsxRuntime classic */
// /** @jsx jsx */
// import { jsx } from '@emotion/core';
// import React, { Fragment, useEffect, useState } from 'react';
// import {
//   Modal,
//   Spin,
//   Button,
//   Form,
//   message,
//   Input,
//   Select,
//   Col,
//   Row,
//   Card,
//   Tag,
//   Space,
//   Empty,
//   Typography,
// } from 'antd';
// import {
//   UserOutlined,
//   MailOutlined,
//   PhoneOutlined,
//   EnvironmentOutlined,
//   GlobalOutlined,
//   ApartmentOutlined,
//   InfoCircleOutlined,
//   SearchOutlined,
// } from '@ant-design/icons';
// import { useIntl } from 'react-intl';
// import { useThemeSwitcher } from 'react-css-theme-switcher';
// import doReturnTheme from '~src/styles/themeEngine';
// import icon from '~components/_common/icon/icon';
// import { useProjectId } from '~src/hooks/useProjectId';
// import { useQuery, useMutation, queryCache } from 'react-query';
// import {
//   createProjectContact,
//   deleteProjectContact,
//   getProjectContactsList,
//   patchProjectContact,
// } from '~src/services/api';
// import { ContactInformationVM } from '~src/types/db.d.ts';
//
// const { Option } = Select;
// const { Text } = Typography;
//
// const typeItems = [
//   { label: 'Personal contact card', key: '1000' },
//   { label: 'Business contact card', key: '2000' },
// ];
//
// const ResourceSetting = ({ state, onCancel }) => {
//   const { currentTheme } = useThemeSwitcher();
//   const theme = doReturnTheme(currentTheme);
//   const intl = useIntl();
//   const projectId = useProjectId();
//
//   const [form] = Form.useForm();
//   const [editForm] = Form.useForm();
//
//   const [mode, setMode] = useState<'view' | 'create' | 'edit'>('view');
//   const [selectedType, setSelectedType] = useState<string>();
//   const [
//     editingContact,
//     setEditingContact,
//   ] = useState<ContactInformationVM | null>(null);
//   const [filterType, setFilterType] = useState<'all' | '1000' | '2000'>('all');
//   const [searchTerm, setSearchTerm] = useState('');
//
//   const { data: contacts, isLoading } = useQuery(
//     ['contacts', projectId],
//     () => getProjectContactsList(null, { projectId }),
//     { enabled: !!projectId }
//   );
//
//   const [doCreateContact, { isLoading: isCreating }] = useMutation(
//     (data) => createProjectContact(projectId, data),
//     {
//       onSuccess: () => {
//         message.success('Contact created!');
//         queryCache.invalidateQueries(['contacts', projectId]);
//         setMode('view');
//         form.resetFields();
//       },
//       onError: () => message.error('Failed to create contact'),
//     }
//   );
//
//   const [doPatchContact, { isLoading: isPatching }] = useMutation(
//     ({ contact_key, contactData }) =>
//       patchProjectContact(projectId, contact_key, contactData),
//     {
//       onSuccess: () => {
//         message.success('Contact updated!');
//         queryCache.invalidateQueries(['contacts', projectId]);
//         setMode('view');
//         setEditingContact(null);
//       },
//       onError: () => message.error('Failed to update contact'),
//     }
//   );
//
//   const [doDeleteContact] = useMutation(
//     (contactKey: string) => deleteProjectContact(projectId, contactKey),
//     {
//       onSuccess: () => {
//         message.success('Contact deleted!');
//         queryCache.invalidateQueries(['contacts', projectId]);
//         setMode('view');
//       },
//       onError: () => message.error('Delete failed'),
//     }
//   );
//
//   const resetState = () => {
//     form.resetFields();
//     editForm.resetFields();
//     setMode('view');
//     setSelectedType(undefined);
//     setEditingContact(null);
//     setFilterType('all');
//   };
//
//   useEffect(() => {
//     if (state) {
//       resetState();
//     }
//   }, [state]);
//
//   const handleSubmit = async (values) => {
//     await doCreateContact(values);
//   };
//
//   const handleEditSubmit = async (values) => {
//     if (!editingContact) return;
//     await doPatchContact({
//       contact_key: editingContact.contact_key,
//       contactData: values,
//     });
//   };
//
//   const showDeleteConfirm = (contactKey: string, contactName: string) => {
//     Modal.confirm({
//       title: 'Delete Contact',
//       content: `Are you sure you want to delete the contact "${contactName}"?`,
//       okText: 'Delete',
//       okType: 'danger',
//       cancelText: 'Cancel',
//       onOk: () => doDeleteContact(contactKey),
//     });
//   };
//
//   const handleCancel = () => {
//     resetState();
//     onCancel();
//   };
//
//   const filteredContacts = contacts
//     ?.filter((c) => (filterType === 'all' ? true : c.type === filterType))
//     .filter((c) => {
//       if (!searchTerm) return true;
//       const lowerCaseSearch = searchTerm.toLowerCase().trim();
//
//       let searchableFields = [];
//
//       // Check the contact type and build the search array accordingly
//       if (c.type === '1000') {
//         // --- Fields for PERSONAL contacts ---
//         searchableFields = [
//           c.title,
//           c.name_1,
//           c.name_2,
//           c.user_title_1,
//           c.user_title_2,
//           c.email_1,
//           c.email_2,
//           c.phone_1,
//           c.phone_2,
//           c.address_1,
//           c.address_2,
//           c.location_1,
//           c.location_2,
//         ];
//       } else {
//         // --- Fields for BUSINESS contacts ---
//         searchableFields = [
//           // Business-specific fields
//           c.title,
//           c.company_title,
//           c.company_subtitle,
//           c.company_email,
//           c.company_url,
//           c.postal_code,
//           c.city,
//           c.country,
//           // Common fields
//           c.address_1,
//           c.address_2,
//           c.location_1,
//           c.location_2,
//           // Personal fields for the contact person at the business
//           c.name_1,
//           c.name_2,
//           c.user_title_1,
//           c.user_title_2,
//           c.email_1,
//           c.email_2,
//           c.phone_1,
//           c.phone_2,
//         ];
//       }
//
//       return searchableFields.some(
//         (field) =>
//           field && field.toString().toLowerCase().includes(lowerCaseSearch)
//       );
//     });
//
//   return (
//     <Modal
//       title={
//         <div
//           style={{
//             display: 'flex',
//             alignItems: 'center',
//             fontSize: '18px',
//             fontWeight: 'bold',
//           }}>
//           {icon('far', 'address-card', {
//             color: theme.colors.secondary,
//             fontSize: '20px',
//           })}
//           {intl.formatMessage({ id: 'project-contacts-settings' })}
//         </div>
//       }
//       centered
//       visible={state}
//       onCancel={handleCancel}
//       footer={null}
//       closeIcon={icon(
//         'far',
//         'times',
//         { color: theme.colors.darkGray, fontSize: '20px' },
//         'close'
//       )}
//       width={1100}>
//       {isLoading ? (
//         <div
//           style={{
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'center',
//             height: '500px',
//           }}>
//           <Spin size="large" />
//         </div>
//       ) : (
//         <Row gutter={24}>
//           <Col
//             span={10}
//             css={{
//               maxHeight: '60vh',
//               overflowY: 'auto',
//               paddingRight: '12px',
//             }}>
//             <div
//               style={{
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 alignItems: 'center',
//                 marginBottom: 12,
//               }}>
//               <b style={{ fontSize: '16px' }}>Contacts</b>
//               <Button
//                 type="primary"
//                 onClick={() => {
//                   setMode('create');
//                   form.resetFields();
//                 }}>
//                 Add New
//               </Button>
//             </div>
//
//             <Row gutter={8} style={{ marginBottom: 16 }}>
//               <Col span={16}>
//                 <Input
//                   prefix={<SearchOutlined />}
//                   placeholder="Search..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   allowClear
//                 />
//               </Col>
//               <Col span={8}>
//                 <Select
//                   value={filterType}
//                   onChange={setFilterType}
//                   style={{ width: '100%' }}>
//                   <Option value="all">Show All</Option>
//                   <Option value="1000">Personal Only</Option>
//                   <Option value="2000">Business Only</Option>
//                 </Select>
//               </Col>
//             </Row>
//
//             {filteredContacts && filteredContacts.length > 0 ? (
//               <Space direction="vertical" style={{ width: '100%' }}>
//                 {filteredContacts.map((item: ContactInformationVM) => (
//                   <Card
//                     key={item.contact_key}
//                     size="small"
//                     actions={[
//                       <Button
//                         type="text"
//                         onClick={() => {
//                           // *** THE FIX IS HERE ***
//                           // 1. First, reset the form completely to clear any stale values.
//                           editForm.resetFields();
//                           // 2. Then, set the new contact and its values.
//                           setEditingContact(item);
//                           editForm.setFieldsValue(item);
//                           setMode('edit');
//                         }}>
//                         Edit
//                       </Button>,
//                       <Button
//                         type="text"
//                         danger
//                         onClick={() =>
//                           showDeleteConfirm(
//                             item.contact_key,
//                             item.name_1 || item.company_title
//                           )
//                         }>
//                         Delete
//                       </Button>,
//                     ]}>
//                     <Card.Meta
//                       title={
//                         <div
//                           style={{
//                             display: 'flex',
//                             alignItems: 'center',
//                             gap: '8px',
//                           }}>
//                           {item.type === '1000' ? (
//                             <UserOutlined />
//                           ) : (
//                             <ApartmentOutlined />
//                           )}
//                           <Text strong>
//                             {item.title || item.name_1 || item.company_title}
//                           </Text>
//                         </div>
//                       }
//                       description={
//                         item.type === '1000' ? (
//                           <Tag color="blue">Personal</Tag>
//                         ) : (
//                           <Tag color="green">Business</Tag>
//                         )
//                       }
//                     />
//                     <div style={{ marginTop: 12, paddingLeft: 4 }}>
//                       <Space direction="vertical" size="small">
//                         {item.type === '1000' ? (
//                           <Fragment>
//                             {item.user_title_1 && (
//                               <Text>
//                                 <InfoCircleOutlined /> {item.user_title_1}
//                                 {item.user_title_2 && ` / ${item.user_title_2}`}
//                               </Text>
//                             )}
//                             {item.email_1 && (
//                               <Text>
//                                 <MailOutlined /> {item.email_1}
//                                 {item.email_2 && ` / ${item.email_2}`}
//                               </Text>
//                             )}
//                             {item.phone_1 && (
//                               <Text>
//                                 <PhoneOutlined /> {item.phone_1}
//                                 {item.phone_2 && ` / ${item.phone_2}`}
//                               </Text>
//                             )}
//                             {item.address_1 && (
//                               <Text>
//                                 <EnvironmentOutlined /> {item.address_1}
//                                 {item.address_2 && `, ${item.address_2}`}
//                               </Text>
//                             )}
//                           </Fragment>
//                         ) : (
//                           <Fragment>
//                             {item.company_email && (
//                               <Text>
//                                 <MailOutlined /> {item.company_email}
//                               </Text>
//                             )}
//                             {item.company_url && (
//                               <Text>
//                                 <GlobalOutlined /> {item.company_url}
//                               </Text>
//                             )}
//                             {item.address_1 && (
//                               <Text>
//                                 <EnvironmentOutlined /> {item.address_1},{' '}
//                                 {item.postal_code} {item.city}
//                               </Text>
//                             )}
//                             {item.country && (
//                               <Text>
//                                 <GlobalOutlined /> {item.country} (
//                                 {item.timezone})
//                               </Text>
//                             )}
//                           </Fragment>
//                         )}
//                       </Space>
//                     </div>
//                   </Card>
//                 ))}
//               </Space>
//             ) : (
//               <Empty
//                 description="No contacts found."
//                 style={{ marginTop: '48px' }}>
//                 <Button type="primary" onClick={() => setMode('create')}>
//                   Create First Contact
//                 </Button>
//               </Empty>
//             )}
//           </Col>
//
//           <Col
//             span={14}
//             css={{
//               maxHeight: '60vh',
//               overflowY: 'auto',
//               paddingRight: '12px',
//             }}>
//             {mode === 'view' && (
//               <div style={{ textAlign: 'center', paddingTop: '80px' }}>
//                 <Empty
//                   image={Empty.PRESENTED_IMAGE_SIMPLE}
//                   description={
//                     <span>
//                       Select a contact to edit <br /> or create a new one.
//                     </span>
//                   }
//                 />
//               </div>
//             )}
//
//             {mode === 'create' && (
//               <div>
//                 <b style={{ fontSize: '16px' }}>Create New Contact</b>
//                 <Form
//                   form={form}
//                   layout="vertical"
//                   onFinish={handleSubmit}
//                   onValuesChange={(changedValues) => {
//                     if ('type' in changedValues)
//                       setSelectedType(changedValues.type);
//                   }}>
//                   <Form.Item
//                     name="type"
//                     label="Type"
//                     rules={[{ required: true }]}>
//                     <Select
//                       placeholder="Select contact type"
//                       allowClear
//                       onChange={(value) => setSelectedType(value)}>
//                       {typeItems.map((type) => (
//                         <Option key={type.key} value={type.key}>
//                           {type.label}
//                         </Option>
//                       ))}
//                     </Select>
//                   </Form.Item>
//                   {selectedType === '1000' && (
//                     <Fragment>
//                       <Row gutter={16}>
//                         <Col span={12}>
//                           <Form.Item
//                             name="name_1"
//                             label="Name"
//                             rules={[{ required: true }]}>
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                         <Col span={12}>
//                           <Form.Item name="name_2" label="Name 2">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                       </Row>
//                       <Row gutter={16}>
//                         <Col span={12}>
//                           <Form.Item name="user_title_1" label="Title 1">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                         <Col span={12}>
//                           <Form.Item name="user_title_2" label="Title 2">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                       </Row>
//                       <Row gutter={16}>
//                         <Col span={12}>
//                           <Form.Item
//                             name="email_1"
//                             label="Email"
//                             rules={[{ required: true }]}>
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                         <Col span={12}>
//                           <Form.Item name="email_2" label="Email 2">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                       </Row>
//                       <Row gutter={16}>
//                         <Col span={12}>
//                           <Form.Item
//                             name="phone_1"
//                             label="Phone"
//                             rules={[{ required: true }]}>
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                         <Col span={12}>
//                           <Form.Item name="phone_2" label="Phone 2">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                       </Row>
//                       <Row gutter={16}>
//                         <Col span={12}>
//                           <Form.Item name="address_1" label="Address 1">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                         <Col span={12}>
//                           <Form.Item name="address_2" label="Address 2">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                       </Row>
//                     </Fragment>
//                   )}
//                   {selectedType === '2000' && (
//                     <Fragment>
//                       <Row gutter={16}>
//                         <Col span={12}>
//                           <Form.Item
//                             name="company_title"
//                             label="Company Title"
//                             rules={[{ required: true }]}>
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                         <Col span={12}>
//                           <Form.Item
//                             name="company_subtitle"
//                             label="Company Subtitle">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                       </Row>
//                       <Row gutter={16}>
//                         <Col span={12}>
//                           <Form.Item
//                             name="company_email"
//                             label="Company Email"
//                             rules={[{ required: true }]}>
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                         <Col span={12}>
//                           <Form.Item name="company_url" label="Company URL">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                       </Row>
//                       <Row gutter={16}>
//                         <Col span={12}>
//                           <Form.Item name="location_1" label="Location 1">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                         <Col span={12}>
//                           <Form.Item name="location_2" label="Location 2">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                       </Row>
//                       <Row gutter={16}>
//                         <Col span={12}>
//                           <Form.Item name="address_1" label="Address 1">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                         <Col span={12}>
//                           <Form.Item name="address_2" label="Address 2">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                       </Row>
//                       <Row gutter={16}>
//                         <Col span={12}>
//                           <Form.Item name="postal_code" label="Postal Code">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                         <Col span={12}>
//                           <Form.Item name="city" label="City">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                       </Row>
//                       <Row gutter={16}>
//                         <Col span={12}>
//                           <Form.Item name="region_1" label="Region 1">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                         <Col span={12}>
//                           <Form.Item name="region_2" label="Region 2">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                       </Row>
//                       <Row gutter={16}>
//                         <Col span={12}>
//                           <Form.Item name="country" label="Country">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                         <Col span={12}>
//                           <Form.Item name="timezone" label="Timezone">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                       </Row>
//                     </Fragment>
//                   )}
//                   {selectedType && (
//                     <Button
//                       type="primary"
//                       htmlType="submit"
//                       loading={isCreating}>
//                       Create Contact
//                     </Button>
//                   )}
//                 </Form>
//               </div>
//             )}
//
//             {mode === 'edit' && editingContact && (
//               <div>
//                 <b style={{ fontSize: '16px' }}>
//                   Edit: {editingContact.name_1 || editingContact.company_title}
//                 </b>
//                 <Form
//                   form={editForm}
//                   layout="vertical"
//                   onFinish={handleEditSubmit}>
//                   <Form.Item name="type" label="Type">
//                     <Select disabled>
//                       <Option value="1000">Personal</Option>
//                       <Option value="2000">Business</Option>
//                     </Select>
//                   </Form.Item>
//                   {editingContact.type === '1000' && (
//                     <Fragment>
//                       <Row gutter={16}>
//                         <Col span={12}>
//                           <Form.Item name="name_1" label="Name">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                         <Col span={12}>
//                           <Form.Item name="name_2" label="Name 2">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                       </Row>
//                       <Row gutter={16}>
//                         <Col span={12}>
//                           <Form.Item name="user_title_1" label="Title 1">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                         <Col span={12}>
//                           <Form.Item name="user_title_2" label="Title 2">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                       </Row>
//                       <Row gutter={16}>
//                         <Col span={12}>
//                           <Form.Item name="email_1" label="Email">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                         <Col span={12}>
//                           <Form.Item name="email_2" label="Email 2">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                       </Row>
//                       <Row gutter={16}>
//                         <Col span={12}>
//                           <Form.Item name="phone_1" label="Phone">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                         <Col span={12}>
//                           <Form.Item name="phone_2" label="Phone 2">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                       </Row>
//                       <Row gutter={16}>
//                         <Col span={12}>
//                           <Form.Item name="address_1" label="Address 1">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                         <Col span={12}>
//                           <Form.Item name="address_2" label="Address 2">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                       </Row>
//                       <Row gutter={16}>
//                         <Col span={12}>
//                           <Form.Item name="location_1" label="Location 1">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                         <Col span={12}>
//                           <Form.Item name="location_2" label="Location 2">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                       </Row>
//                     </Fragment>
//                   )}
//                   {editingContact.type === '2000' && (
//                     <Fragment>
//                       <Row gutter={16}>
//                         <Col span={12}>
//                           <Form.Item name="company_title" label="Company Title">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                         <Col span={12}>
//                           <Form.Item
//                             name="company_subtitle"
//                             label="Company Subtitle">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                       </Row>
//                       <Row gutter={16}>
//                         <Col span={12}>
//                           <Form.Item name="company_email" label="Company Email">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                         <Col span={12}>
//                           <Form.Item name="company_url" label="Company URL">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                       </Row>
//                       <Row gutter={16}>
//                         <Col span={12}>
//                           <Form.Item name="location_1" label="Location 1">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                         <Col span={12}>
//                           <Form.Item name="location_2" label="Location 2">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                       </Row>
//                       <Row gutter={16}>
//                         <Col span={12}>
//                           <Form.Item name="address_1" label="Address 1">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                         <Col span={12}>
//                           <Form.Item name="address_2" label="Address 2">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                       </Row>
//                       <Row gutter={16}>
//                         <Col span={12}>
//                           <Form.Item name="postal_code" label="Postal Code">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                         <Col span={12}>
//                           <Form.Item name="city" label="City">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                       </Row>
//                       <Row gutter={16}>
//                         <Col span={12}>
//                           <Form.Item name="region_1" label="Region 1">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                         <Col span={12}>
//                           <Form.Item name="region_2" label="Region 2">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                       </Row>
//                       <Row gutter={16}>
//                         <Col span={12}>
//                           <Form.Item name="country" label="Country">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                         <Col span={12}>
//                           <Form.Item name="timezone" label="Timezone">
//                             <Input />
//                           </Form.Item>
//                         </Col>
//                       </Row>
//                     </Fragment>
//                   )}
//                   <Space>
//                     <Button
//                       type="primary"
//                       htmlType="submit"
//                       loading={isPatching}>
//                       Save Changes
//                     </Button>
//                     <Button onClick={() => setMode('view')}>Cancel</Button>
//                   </Space>
//                 </Form>
//               </div>
//             )}
//           </Col>
//         </Row>
//       )}
//     </Modal>
//   );
// };
//
// export default ResourceSetting;
